<label class="container-input-check d-block position-relative my-4">
  <p class="container-input-check__label">
    <ng-content select="[slot=descriptionRef]"></ng-content>
  </p>
  <ng-content select="[slot=inputRef]"></ng-content>
  <span class="container-input-check__checkmark position-absolute"></span>
</label>
